import Product from "./Product";
import BaseModel from "./BaseModel";

export default class InsulationCut extends BaseModel {

	static entity = 'insulation_cuts';
	static route = 'insulation-cuts';
	static plural = 'insulation_cuts';
	static singular = 'insulation_cut';

	static fields () {
		return {
			id: this.attr(null),
			product_id: this.attr(null),
			product: this.belongsTo(Product, 'product_id'),
			thickness: this.attr(null),
			thickness_unit: this.attr(null),
			width: this.attr(null),
			width_unit: this.attr(null),
			length: this.attr(null),
			length_unit: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null)
		}
	}

	static parseFilteredName(thickness, thickness_unit, width, width_unit, length, length_unit) {
		let parts = [
			(thickness ? [thickness,thickness_unit,'(TH)'].join('') : null),
			(width ? [width,width_unit,'(W)'].join('') : null),
			(length ? [length,length_unit,'(L)'].join('') : null)
		].filter(i => !!i);
		return InsulationCut.decodeHTMLEntities(parts.join(' x '));
	}

	getFilteredName() {
		return InsulationCut.parseFilteredName(this.thickness, this.thickness_unit, this.width, this.width_unit, this.length, this.length_unit);
	}

}
